import { Box } from "@mui/material";
import { styled } from "@mui/system";

const FlexColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export default FlexColumn;
